import { adminHttpClient } from '../../../commons/adminHttpClient'

export type SetIchraRenewalProductClassAllowancesRequest = {
  productClassId: string
  offerSameAllowance: boolean
  allowanceAmounts: string[]
}

const setIchraRenewalProductClassAllowances = (
  payload: SetIchraRenewalProductClassAllowancesRequest,
): Promise<void> => {
  return adminHttpClient.put(`/Benefit/BenefitRenewal/Ichra/SetIchraRenewalProductClassAllowances`, payload)
}

export default setIchraRenewalProductClassAllowances
